<div class="code">{{ code }}</div>
<div class="title">{{ title }}</div>
<div class="user-content"><ng-content></ng-content></div>
